import React, { useEffect, useRef, useState } from 'react';
type FitToViewportProps = {
  children: React.ReactNode;
};
const SETTLE_MS = 200;
const MIN_SCALE = 0.62;
const DESKTOP_QUERY = '(min-width: 1024px)';

/**
 * On desktop, scales the whole presentation down so each screen fits the viewport
 * without scrolling. On smaller screens content flows and scrolls normally.
 */
export function FitToViewport({
  children
}: FitToViewportProps) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [enabled, setEnabled] = useState(() => window.matchMedia(DESKTOP_QUERY).matches);
  const [vh, setVh] = useState(() => window.innerHeight);
  const [contentH, setContentH] = useState(0);
  useEffect(() => {
    const mq = window.matchMedia(DESKTOP_QUERY);
    const onChange = () => setEnabled(mq.matches);
    const onResize = () => setVh(window.innerHeight);
    mq.addEventListener('change', onChange);
    window.addEventListener('resize', onResize);
    return () => {
      mq.removeEventListener('change', onChange);
      window.removeEventListener('resize', onResize);
    };
  }, []);
  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    let t: number | undefined;
    const ro = new ResizeObserver(() => {
      window.clearTimeout(t);
      t = window.setTimeout(() => setContentH(el.offsetHeight), SETTLE_MS);
    });
    ro.observe(el);
    return () => {
      ro.disconnect();
      window.clearTimeout(t);
    };
  }, []);
  const scale = enabled && contentH > 0 ? Math.max(MIN_SCALE, Math.min(1, vh / contentH)) : 1;
  return <div className="w-full overflow-hidden" style={enabled && contentH > 0 ? {
    height: Math.max(vh, contentH * scale)
  } : undefined} data-id="element-121" data-mp="3s1b7cp55vdcm">
      <div ref={contentRef} style={{
      width: `${100 / scale}%`,
      transform: scale === 1 ? undefined : `scale(${scale})`,
      transformOrigin: 'top left',
      transition: 'transform 220ms cubic-bezier(0.23, 1, 0.32, 1)'
    }} data-id="element-122" data-mp="3i8vu254t7cy2">
        {children}
      </div>
    </div>;
}